import { createAsyncAction, createAction } from 'typesafe-actions';
import { AnyAction } from 'redux';
import { ThunkAction, ThunkDispatch } from 'redux-thunk';
import { webApiGet, webApiPut } from '../../api/client'
import { OrderSheetData, OrderSheetItemData } from '../../api/models/OrderSheetData';


export const getOrderSheetsAsync = createAsyncAction(
    "GET_ORDER_SHEETS_REQUEST",
    "GET_ORDER_SHEETS_SUCCESS",
    "GET_ORDER_SHEETS_ERROR")<undefined, OrderSheetData[], Error>()


export const getOrderSheetsAsyncThunk = (): ThunkAction<Promise<void>, {}, {}, AnyAction> => {
    return async (dispatch: ThunkDispatch<{}, {}, AnyAction>): Promise<void> => {
        return new Promise<void>((resolve) => {
            dispatch(getOrderSheetsAsync.request())
            webApiGet('/ordersheet',
                (data: OrderSheetData[]) => { dispatch(getOrderSheetsAsync.success(data)); resolve() },
                (err: Error) => { dispatch(getOrderSheetsAsync.failure(err)); resolve() },
                null,
                3
            )
        })
    }
}


export const updateOrderSheetAsync = createAsyncAction(
    "UPDATE_ORDER_SHEET_REQUEST",
    "UPDATE_ORDER_SHEET_SUCCESS",
    "UPDATE_ORDER_SHEET_ERROR")<undefined, OrderSheetData, Error>()


export const updateOrderSheetAsyncThunk = (orderSheet: OrderSheetData): ThunkAction<Promise<void>, {}, {}, AnyAction> => {
    return async (dispatch: ThunkDispatch<{}, {}, AnyAction>): Promise<void> => {

        let obj: OrderSheetData = { ...orderSheet, items: orderSheet.items }

        return new Promise<void>((resolve) => {
            dispatch(updateOrderSheetAsync.request())
            webApiPut('/ordersheet/' + orderSheet.id,
                obj,
                () => { dispatch(updateOrderSheetAsync.success(orderSheet)); resolve() },
                (err: Error) => { dispatch(updateOrderSheetAsync.failure(err)); resolve() }
            )
        })
    }
}


export const addOrderItem = createAction('ADD_TO_ORDER')<OrderSheetItemData>()
export const removeOrderItem = createAction('REMOVE_FROM_ORDER')<OrderSheetItemData>()
export const changeItemQuantity = createAction('ORDER_ITEM_QUANTITY_CHANGE')<OrderSheetItemData>()
export const setCurrentOrderSheet = createAction('SET_CURRENT_ORDER_SHEET')<number>()
